import { Alert, Box, Grid, Stack, Typography } from '@mui/material';
import { useParams } from 'react-router';

import { MarkedAsDeletedAlert } from '../../components/MarkedAsDeletedAlert';
import { PageLoading } from '../../components/PageLoading';
import { trpc } from '../../trpc';
import { VeranstaltungHeaderCard } from './components/VeranstaltungHeaderCard';
import { VeranstaltungsAblaufComponent } from './components/VeranstaltungsAblaufComponent';
import { VeranstaltungsAusstattungRefComponent } from './components/VeranstaltungsAusstattungRefComponent';
import { VeranstaltungsAusstattungTNComponent } from './components/VeranstaltungsAusstattungTNComponent';
import { VeranstaltungsAusstattungVAComponent } from './components/VeranstaltungsAusstattungVAComponent';
import { VeranstaltungsCapacityComponent } from './components/VeranstaltungsCapacityComponent';
import { VeranstaltungsKontaktpersonComponent } from './components/VeranstaltungsKontaktpersonComponent';
import { VeranstaltungsMiroComponent } from './components/VeranstaltungsMiroComponent';
import { VeranstaltungsOrtComponent } from './components/VeranstaltungsOrtComponent';
import { VeranstaltungsReferentenComponent } from './components/VeranstaltungsReferentenComponent';
import { VeranstaltungsRefFragebogenComponent } from './components/VeranstaltungsRefFregabogen';
import { VeranstaltungsVCComponent } from './components/VeranstaltungsVCComponent';

export const VeranstaltungPage = () => {
  const params = useParams();
  const veranstaltungQuery = trpc.veranstaltung.getVeranstaltungBySapId.useQuery(
    { sapId: Number(params.sapid) },
    { retry: 3 },
  );
  const veranstaltung = veranstaltungQuery.data;

  if (veranstaltungQuery.isLoading) {
    return <PageLoading msg={`Lade Veranstaltung ${params.sapid}`} withoutLogo />;
  }

  if (!veranstaltung) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: 5,
          width: '100%',
          height: '100%',
        }}
      >
        <Alert severity="warning" sx={{ width: 'fit-content' }}>
          <Typography variant="headingXxs">
            Die gesuchte Veranstaltung konnte leider nicht gefunden werden...
          </Typography>
        </Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%' }}>
      <MarkedAsDeletedAlert geloeschtWeil={veranstaltung.geloeschtWeil ?? undefined} />
      <VeranstaltungHeaderCard veranstaltung={veranstaltung} />
      <Grid container spacing={2}>
        <Grid size={4}>
          <Stack spacing={2}>
            <VeranstaltungsOrtComponent veranstaltung={veranstaltung} />
            <VeranstaltungsAusstattungVAComponent veranstaltung={veranstaltung} />
            <VeranstaltungsReferentenComponent veranstaltung={veranstaltung} />
          </Stack>
        </Grid>
        <Grid size={4}>
          <Stack spacing={2}>
            <VeranstaltungsAblaufComponent veranstaltung={veranstaltung} />
            <VeranstaltungsAusstattungTNComponent veranstaltung={veranstaltung} />
            <VeranstaltungsVCComponent veranstaltung={veranstaltung} />
            <VeranstaltungsKontaktpersonComponent veranstaltung={veranstaltung} />
          </Stack>
        </Grid>
        <Grid size={4}>
          <Stack spacing={2}>
            <VeranstaltungsCapacityComponent veranstaltung={veranstaltung} />
            <VeranstaltungsAusstattungRefComponent veranstaltung={veranstaltung} />
            <VeranstaltungsRefFragebogenComponent veranstaltung={veranstaltung} />
            <VeranstaltungsMiroComponent veranstaltung={veranstaltung} />
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};
